import { AbstractControl, ValidatorFn } from "@angular/forms";
import {
  VALIDATION_PASSED,
  ValidationErrorKey,
} from "projects/pax-ui/components/form-field/validators/general-validation.";

// Matches everything which has at least two characters
const NAME_REGEX = /^.{2,}$/;

export const nameValidator: ValidatorFn = (
  control: AbstractControl<string, string>,
) => {
  if (!control.value) {
    // We do not apply the validator in case the user has not entered a value yet
    // Otherwise we could end up with two error messages for an empty submitted field (required & nameValidator)
    return VALIDATION_PASSED;
  }

  return NAME_REGEX.exec(control.value)
    ? VALIDATION_PASSED
    : { [ValidationErrorKey.NAME]: true };
};
